import React from 'react';

/**
 * Typo the cat — Typo Notes mascot poses from brand_kit/.
 * Served from browser-entry/public/brand_kit/.
 */
export const TYPO_POSES = {
  main: {
    src: '/brand_kit/typo_main.png',
    width: 1024,
    height: 1024,
    alt: 'Typo the cat at a typewriter',
  },
  'belly-up': {
    src: '/brand_kit/belly_up.png',
    width: 1400,
    height: 1092,
    alt: 'Typo the cat, belly up',
  },
  napping: {
    src: '/brand_kit/napping.png',
    width: 1400,
    height: 972,
    alt: 'Typo the cat, napping',
  },
  'napping-on-back': {
    src: '/brand_kit/napping_on_back.png',
    width: 1400,
    height: 737,
    alt: 'Typo the cat, napping on their back',
  },
  'owl-ears': {
    src: '/brand_kit/owl_ears.png',
    width: 1169,
    height: 1400,
    alt: 'Typo the cat, ears up',
  },
  'scared-404': {
    src: '/brand_kit/scared_404.png',
    width: 1400,
    height: 1225,
    alt: 'Typo the cat, looking lost',
  },
  stretching: {
    src: '/brand_kit/big_stretch.png',
    width: 796,
    height: 1400,
    alt: 'Typo the cat, stretching',
  },
  'with-a-letter': {
    src: '/brand_kit/sign_up_with_a_letter.png',
    width: 1400,
    height: 1360,
    alt: 'Typo the cat with a letter',
  },
} as const;

export type TypoPose = keyof typeof TYPO_POSES;

/** Poses fine for waiting / empty screens — skips the lost/404 face and the letter. */
export const TYPO_LOADING_POSES = (
  Object.keys(TYPO_POSES) as TypoPose[]
).filter(
  (pose) =>
    pose !== 'scared-404' && pose !== 'with-a-letter' && pose !== 'main',
);

export function pickTypoLoadingPose(): TypoPose {
  return TYPO_LOADING_POSES[
    Math.floor(Math.random() * TYPO_LOADING_POSES.length)
  ]!;
}

export type TypoCatProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'alt' | 'width' | 'height'
> & {
  pose?: TypoPose;
  /** When true (default), exposed as decorative (empty alt, aria-hidden). */
  decorative?: boolean;
  alt?: string;
};

export function TypoCat({
  pose = 'main',
  className,
  decorative = true,
  alt,
  ...props
}: TypoCatProps) {
  const art = TYPO_POSES[pose] ?? TYPO_POSES.main;

  return (
    <img
      src={art.src}
      alt={decorative ? '' : (alt ?? art.alt)}
      width={art.width}
      height={art.height}
      className={className}
      aria-hidden={decorative ? true : undefined}
      {...props}
    />
  );
}
